import {Component, inject, OnInit, viewChild} from '@angular/core';
import {MapComponent} from "../components/map.component";
import {DataService} from "../services/data.service";
import {MapService, MarkerData} from "../services/map.service";
import {forkJoin} from "rxjs";
import {AccessService} from "../services/access.service";

@Component({
    selector: 'app-maps',
    imports: [MapComponent],
    template: `
        <h2 class="fw-bold"><i class="fa-solid fa-globe me-2 mb-3"></i>Karte</h2>

        <app-map #mapComponent [ID]="'locations'" [height]="height"/>
    `
})
export class MapsComponent implements OnInit {

    private dataService = inject(DataService);
    private mapService = inject(MapService);
    private accessService = inject(AccessService);

    mapComponent = viewChild<MapComponent>('mapComponent');

    height = (window.innerHeight - 165) + 'px';
    stores: any[] = [];

    ngOnInit() {
        this.dataService.request("Store/listForMap", {}).subscribe(response => {
            this.stores = response.stores;

            // Get coordinates for each store and add to map
            const geocodeRequests = this.stores.map(store =>
                this.mapService.codeAddress(store.address)
            );

            forkJoin(geocodeRequests).subscribe(results => {
                const markerData: MarkerData[] = results.map((result, index) => ({
                    latLng: result[0].geometry.location,
                    infoWindow: this.stores[index].name,
                    icon: this.stores[index].status === 'In Betrieb' ? ('assets/img/logos/' + this.accessService.client.logoSmall) : undefined,
                    storeId: this.stores[index].id
                }));

                this.mapComponent().addMarkerData(markerData);
            });
        });
    }
}
